// extracted by mini-css-extract-plugin
module.exports = {"ltr":"CrowdstrikeOutage-module__ltr___Ikl4Z"};